import { useEffect, useRef } from 'react';

interface ReservationSuccessAnimationProps {
  onComplete?: () => void;
}

export const ReservationSuccessAnimation = ({ onComplete }: ReservationSuccessAnimationProps) => {
  const castleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const colors = ['#ffd700', '#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7'];
    const timeouts: ReturnType<typeof setTimeout>[] = [];

    // 3 bursts instead of continuous rAF loop
    const burst = (delay: number, opts: Partial<Parameters<typeof import('canvas-confetti')['default']>[0]>) => {
      timeouts.push(setTimeout(() => {
        import('canvas-confetti').then((confetti) => confetti.default({ colors, ...opts }));
      }, delay));
    };

    burst(100, { particleCount: 80, spread: 70, origin: { y: 0.6 } });
    burst(300, { particleCount: 60, angle: 60, spread: 55, origin: { x: 0, y: 0.6 } });
    burst(500, { particleCount: 60, angle: 120, spread: 55, origin: { x: 1, y: 0.6 } });
    burst(800, { particleCount: 100, spread: 90, origin: { x: 0.5, y: 0.4 } });

    // Castle animation
    timeouts.push(setTimeout(() => {
      if (castleRef.current) castleRef.current.classList.add('animate-castle-enter');
    }, 500));

    // Auto-dismiss
    timeouts.push(setTimeout(() => onComplete?.(), 4000));

    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-2xl p-8 text-center max-w-md w-full shadow-2xl animate-scale-in">
        <div 
          ref={castleRef} 
          className="text-8xl mb-6 scale-[0.3] opacity-0 transition-all duration-[1500ms] ease-[cubic-bezier(0.68,-0.55,0.265,1.55)]"
        >
          🏰
        </div>
        <h2 className="text-2xl font-bold text-primary mb-4 animate-pulse">
          Demande envoyée !
        </h2>
        <p className="text-gray-600">
          Nous avons bien reçu votre demande de réservation. 
          Vous recevrez une confirmation par email très bientôt !
        </p>
      </div>
    </div>
  );
};